import { contact } from "../data/portfolio";
import ArrowIcon from "./ArrowIcon";

export default function Contact() {
  return (
    <section className="contact" id="contact" aria-labelledby="contact-title">
      <div className="contact__inner">
        <p className="section-kicker section-kicker--light" data-reveal>
          03 / Contact
        </p>
        <div className="contact__heading" data-reveal>
          <h2 id="contact-title">{contact.heading}</h2>
          <span className="contact__heading-arrow" aria-hidden="true">
            <ArrowIcon diagonal />
          </span>
        </div>
        <div className="contact__lower" data-reveal>
          <p>{contact.availability}</p>
          <nav className="contact__links" aria-label="Contact links">
            {contact.links.map((link) => {
              const external = link.href.startsWith("http");
              return (
                <a
                  href={link.href}
                  key={link.label}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noreferrer" : undefined}
                >
                  {link.label}
                  <span aria-hidden="true">↗</span>
                </a>
              );
            })}
          </nav>
        </div>
      </div>
    </section>
  );
}
